<template>
  <div id="backups">
    <p class="title">备份恢复</p>
    <!-- <el-button :disabled="$store.state.isLook||!$store.state.functionList.includes('systemConfigEdit')" type="primary" @click="upDate" style="padding: 10px 28px; position: absolute; top: 0; right: 0;">保存</el-button> -->
    <div class="content">
      <div class="time">
        上一次备份：<span>{{last}}</span>
        下一次备份：<span>{{next||'-'}}</span>
      </div>
      <div class="lab">
        <p class="lab-title">备份选项： </p>
        <el-radio v-model="radio" :label="1">手动备份</el-radio>
        <el-radio v-model="radio" :label="2">自动备份</el-radio>
        <div>
          <span class="m-r-10">自动备份间隔</span>
          <el-select v-model="value" placeholder="请选择" size="small" :disabled="radio==1">
              <el-option label="1个月" :value="1"></el-option>
              <el-option label="2个月" :value="2"></el-option>
              <el-option label="3个月" :value="3"></el-option>
              <el-option label="4个月" :value="4"></el-option>
              <el-option label="5个月" :value="5"></el-option>
              <el-option label="6个月" :value="6"></el-option>
              <el-option label="7个月" :value="7"></el-option>
              <el-option label="8个月" :value="8"></el-option>
              <el-option label="9个月" :value="9"></el-option>
              <el-option label="10个月" :value="10"></el-option>
              <el-option label="11个月" :value="11"></el-option>
              <el-option label="12个月" :value="12"></el-option>
            </el-select>
        </div>
      </div>
      <div class="lab">
        <p class="lab-title">备份列表： </p>
      </div>
      <div class="list-box">
          <ul class="list-title" style="width: 99%; margin-left: 0;">
              <li>备份时间</li>
              <li>备份类型</li>
              <li>备份大小</li>
          </ul>
          <div class="scroll scroll2">
              <div v-for="item,i in list" :key="i">
                <ul class="list-details">
                  <li>{{changeTime(item.createTime)}}</li>
                  <li>{{item.type==1?'手动备份':'自动备份'}}</li>
                  <li>{{resetSize(item.size)}}</li>
                </ul>
              </div>
          </div>
          <div class="btns">
            <el-button type="primary" :disabled="$store.state.isLook" :loading="backupLoading" size="small" @click="backup">备份</el-button>
            <el-button size="small" :disabled="$store.state.isLook" :loading="restoreLoading" @click="restore">恢复</el-button>
            <el-button size="small" v-if="$store.state.isLook" :disabled="true">下载</el-button>
            <!-- <el-button size="small" @click="download">下载</el-button> -->
            <a :href="'/api/v1/Backup/download?id='+id" class="backup-btn" v-if="!$store.state.isLook">下载</a>
          </div>
      </div>
      <div class="lab">
        <p class="lab-title">备份/恢复日志： </p>
      </div>
      <div class="list-box">
          <ul class="list-title" style="width: 99%; margin-left: 0;">
              <li>动作时间</li>
              <li>动作类型</li>
              <li>用户</li>
          </ul>
          <div class="scroll">
              <div v-for="item,i in log" :key="i">
                <ul class="list-details">
                  <li>{{changeTime(item.createTime)}}</li>
                  <li>{{item.type==0?'自动备份':item.type==1?'手动备份':'恢复'}}</li>
                  <li>{{item.createAccount}}</li>
                </ul>
              </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default{
    data(){
      return {
        radio:1,
        value:1,
        last:'',
        next:'',
        backupLoading:false,
        restoreLoading:false,
        id:null,
        list:[],
        config:{},
        log:[],
        setDisable:true
      }
    },
    created() {
      if(!this.$store.state.functionList.includes('systemConfigBackup')){  //||this.env!='local'
        this.$router.go(-1)
        return
      }
      this.$store.state.activeIndex = '/backups'
      this.$store.state.mask = false
      this.getConfig()
      this.getList()
      this.getLog()
    },
    computed:{
      resetSize(){
        return (size)=>{
          let units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];
          let idx = 0;
          while (size >= 1024 && idx < units.length - 1) {
            size /= 1024;
            idx++;
          }
          return size.toFixed(2) + ' ' + units[idx];
        }
      }
    },
    methods:{
      backup(){
        this.backupLoading=true
        this.post("/Backup/backup").then(res=>{
          if(res.success){
            this.$message({
              type:"success",
              message:"备份成功"
            })
            this.getList()
            this.getLog()
          }else{
            this.$message({
              type:"warning",
              message:"备份失败："+res.message
            })
          }
          this.backupLoading=false
        })
      },
      restore(){
        this.restoreLoading=true
        let options={
          id: this.id
        }
        this.postNoJson("/Backup/restore",options).then(res=>{
          if(res.success){
            this.$message({
              type:"success",
              message:"恢复成功"
            })
          }else{
            this.$message({
              type:"warning",
              message:"恢复失败："+res.message
            })
          }
          this.restoreLoading=false
        })
      },
      download(){
        let options={
          id: this.id
        }
        this.get("/Backup/download",options).then(res=>{
          console.log(res)
          if(res.success){
            this.getList()
            this.getLog()
          }else{
            this.$message({
              type:"warning",
              message:"备份失败："+res.message
            })
          }
        })
      },
      getConfig(){
        this.get("/Backup/getConfig").then(res=>{
          if(res.success){
            this.last=this.changeTime(res.result.last)
            this.next=this.changeTime(res.result.next)
            this.value = res.result.interval
            this.radio = res.result.type
            this.id = res.result.id
            setTimeout(()=>{
              this.setDisable = false
            },200)
          }else{
            setTimeout(()=>{
              this.setDisable = false
            },200)
            this.$message({
              type:"warning",
              message:"获取备份配置失败："+res.message
            })
          }
        })
      },
      getList(){
        this.get("/Backup/getList").then(res=>{
          if(res.success){
            this.list=res.result
          }else{
            this.$message({
              type:"warning",
              message:"获取备份列表失败："+res.message
            })
          }
        })
      },
      getLog(){
        this.get("/Backup/getLog").then(res=>{
          console.log(res)
          if(res.success){
            this.log=res.result
          }else{
            this.$message({
              type:"warning",
              message:"获取日志失败："+res.message
            })
          }
        })
      },
      setConfig(){
        let options={
          id: this.id,
          interval: Number(this.value),
          type: Number(this.radio)
        }
        this.postNoJson("/Backup/setConfig",options).then(res=>{
          if(res.success){
            this.$message({
              type:"success",
              message:"设置成功"
            })
          }else{
            this.$message({
              type:"warning",
              message:"设置失败："+res.message
            })
          }
        })
      },
    },
    watch:{
      radio(){
        if(!this.setDisable){
          this.setConfig()
        }
      },
      value(){
        if(!this.setDisable){
          this.setConfig()
        }
      },
    }
  }
</script>

<style scoped lang="scss">
  #backups{
    max-height: 100%;
    overflow-y: hidden;
    overflow-x: auto;
    position: absolute;
    height: 100%;
    left: 0;
    right: 0;
    top: 0;
    text-align: left;
    .title{
        font-size: 16px;
        text-align: left;
        margin-bottom: 18px;
        margin-left: 16px;
    }
    .content{
        margin:0 16px;
        padding: 25px;
        box-sizing: border-box;
        background: #fff;
        font-size: 14px;
        height: 92%;
        margin-bottom: 20px;
        .lab{
          display: flex;
          justify-content: flex-start;
          align-items: center;
          margin-bottom: 16px;
          .lab-title{
            font-size: 14px;
            margin-left: 14px;
          }
          .m-r-10{
            margin-right: 10px;
          }
        }
        .time{
          font-size: 14px;
          margin-bottom: 16px;
          span{
            font-size: 16px;
            font-weight: bold;
            margin-right: 40px;
          }
        }
    }
  }
  .list-box{
    width: 50%;
    min-width: 600px;
    margin-top: -10px;
    margin-bottom: 26px;
    .btns{
      display: flex;
      justify-content: flex-end;
      margin: 12px 12px 0 0;
      .backup-btn{
        padding: 9px 15px;
        font-size: 12px;
        border-radius: 3px;
        color: #606266;
        border: 1px solid #dcdfe6;
        display: inline-block;
        line-height: 1;
        white-space: nowrap;
        cursor: pointer;
        background: #fff;
        -webkit-appearance: none;
        text-align: center;
        box-sizing: border-box;
        outline: 0;
        margin-left: 10px;
        transition: .1s;
        font-weight: 500;
        &:hover{
          color: #409eff;
          border-color: #c6e2ff;
          background-color: #ecf5ff;
        }
        &.disabled{
          olor: #c0c4cc;
          cursor: not-allowed;
          background-image: none;
          background-color: #fff;
          border-color: #ebeef5;
        }
      }
    }
    .scroll{
        overflow: auto;
        width: 99%;
        max-height: 630px;
        box-sizing: border-box;
        border: 1px solid #f2f2f2;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        position: relative;
        height: 280px;
        &.scroll2{
          height: 150px;
        }
    }

    .list-title{
        background: #eeeeee;
    }
    .list-title,.list-details{
        display: flex;
        justify-content: space-around;
        line-height: 44px;
        font-size: 14px;
        color: #636363;
        li{
          width: 200px;
          margin: 0 20px;
          text-align: left;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          box-sizing: border-box;
        }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/backups/index.vue